/** @jsx jsx */

import { Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import IntegrationSettingsForm from 'app/developer-v3/components/IntegrationSettingsForm';
import { useAvroEvent } from 'app/developer-v3/hooks';
import { BASE_APP_URL } from 'app/developer-v3/constants';

import Alert from './Alert';

import type {
  NewAppFormType,
  FormifiedFieldSchema,
} from 'app/developer-v3/types';

const Styles = {
  root: css`
    margin: 0 auto;
    max-width: 1068px;
    padding: 20px 40px 80px;
  `,
};

type Props = {
  countIntegrations: number;
  formFields: Array<FormifiedFieldSchema>;
  isSaving: boolean;
  onSubmit: (integrationSettings: NewAppFormType) => Promise<void>;
};

function CreateIntegrationPage({
  countIntegrations,
  isSaving,
  onSubmit,
}: Props) {
  const { emitUserInteractionEvent } = useAvroEvent();

  return (
    <div css={Styles.root}>
      <Text
        fontWeight={600}
        margin="0px 0px 20px 0px"
        tag="h1"
        type="PageHeader"
      >
        Create Integration
      </Text>
      {countIntegrations > 0 && <Alert />}
      <IntegrationSettingsForm
        cancelUrl={`${BASE_APP_URL}/`}
        initialSettings={{
          appCategory: undefined,
          description: '',
          homepageUrl: undefined,
          imageFile: null,
          intention: undefined,
          role: undefined,
          subscription: true,
          title: '',
        }}
        isLoading={false}
        isPublished={false}
        isSaving={isSaving}
        onSubmit={async settings => {
          emitUserInteractionEvent({
            eventAction: 'click',
            interactionRawText: 'Create',
            interactionName: 'create_integration',
            interactionGoal: 'Create Zapier integration using the UI',
          });
          await onSubmit(settings);
        }}
        saveText="Create"
      />
    </div>
  );
}

export default CreateIntegrationPage;
